import { useGlobalStore } from '@shared/store';
import { commonApi } from '../../apis';
import { usePrivacyAgreementPage } from '../use-privacy-agreement-page';

// 初始化隐私协议
export const initPrivacyAgreement = async () => {
  try {
    // TODO 环境变量是否改为业务功能相关，某些场景可能不需要调用。比如：本地 mock 登录在之后才执行、或者个别静态页面、活动页面不需要
    // 有账号权限时才处理隐私弹窗逻辑
    if (import.meta.env.PROD && useGlobalStore().hasAccountPermission) {
      // 获取隐私协议授权状态
      const { isAgree, isRedirectAgreement } = await _getAuthStatus();

      // 更新隐私协议同意状态
      useGlobalStore().setIsAllowProtocol(isAgree);

      // 跳转隐私协议页面
      isRedirectAgreement && usePrivacyAgreementPage();
    }
  } catch (err) {
    console.log('初始化隐私协议错误：', err);
  }
};

// 获取隐私协议授权状态
async function _getAuthStatus() {
  let isRedirectAgreement = false; // 是否需要跳转协议页面
  let isAgree = true; // 是否已同意

  try {
    // 获取隐私协议信息
    console.log('获取隐私协议信息');
    const { ret, retdata = {} } = await commonApi.getPrivacyAgreementInfo<any, any>({});
    if (ret === 0) {
      const { status, popupProtocolFlag } = retdata;

      // 更新同意状态：当 status !== '1' 时，表示同意协议；其它情况均为不同意
      isAgree = status !== '1';

      // 更新是否需要跳转协议页面
      isRedirectAgreement = popupProtocolFlag;
    }
  } catch (err) {
    console.log('获取隐私协议信息失败：', err);
  }

  return {
    isAgree,
    isRedirectAgreement,
  };
}
